// Stub: mobile menu trigger for the redesigned navigation. Implemented in a later phase.
function Hamburger() {
  return null
}

export default Hamburger
